import { STORE_AGREEMENT_SELECTION_MODAL_IS_OPEN } from "actions"

export const initialState = {
  isOpen: false,
}

export const AgreementSelectionModalIsOpen = (state = initialState, action) => {
  switch (action.type) {
    case STORE_AGREEMENT_SELECTION_MODAL_IS_OPEN:
      return { ...state, isOpen: action.payload }
    default:
      return state
  }
}

export default AgreementSelectionModalIsOpen
